// extracted by mini-css-extract-plugin
module.exports = {"faq":"y_gyqe","header":"_3JspZV","questions":"_2E2uSj"};